import React from 'react';
import PropTypes from 'prop-types';
import InlineGrid from '../../marvel-ui-grid/InlineGrid';
import StateWrapper from '../StateWrapper';
import ExtraElement from '../ExtraElement';

import sizeStyles from '../Button/style/size.css';

export default function ButtonContent({
  children,
  fullWidth,
  hasErrored,
  hasSucceeded,
  icon,
  isHovered,
  isIconCentered,
  isLoading,
  isSad,
  isStateful,
  size,
}) {
  const stateProps = {
    hasSucceeded,
    hasErrored,
    isStateful,
    size,
  };

  const extraElementProps = {
    fullWidth,
    icon,
    isHovered,
    isIconCentered,
    isLoading,
    isSad,
    size,
  };

  if (isIconCentered) {
    return (
      <StateWrapper {...stateProps}>
        <InlineGrid size="xs">
          <ExtraElement {...extraElementProps} />
          <div className={sizeStyles[size]}>{children}</div>
        </InlineGrid>
      </StateWrapper>
    );
  }
  return (
    <StateWrapper {...stateProps}>
      <ExtraElement {...extraElementProps} />
      <div>{children}</div>
    </StateWrapper>
  );
}

ButtonContent.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  hasErrored: PropTypes.bool,
  hasSucceeded: PropTypes.bool,
  icon: PropTypes.node,
  isHovered: PropTypes.bool,
  isIconCentered: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSad: PropTypes.bool,
  isStateful: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(sizeStyles)),
};

ButtonContent.defaultProps = {
  children: null,
  fullWidth: false,
  hasErrored: false,
  hasSucceeded: false,
  icon: null,
  isHovered: false,
  isIconCentered: false,
  isLoading: false,
  isSad: false,
  isStateful: false,
  size: 'medium',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/ButtonContent/index.js